import { RECEIVE_PRODUCTS } from "../actions/type";

export const productsInitial = {
  products: [],
  symbol: "$",
};

const productReducer = (state = productsInitial, action) => {
  switch (action.type) {
    case RECEIVE_PRODUCTS:
      return {
        ...state,
        products: action.products,
      };
    default:
      return state;
  }
};
export default productReducer;
